module.exports = __webpack_public_path__ + "img/5.2df317c1.png";